'use strict';
import firebase from 'firebase/app';
import 'firebase/auth';

export default function getUID() {
	return new Promise(async (resolve, reject) => {
        // Get the token and refresh it if it has expired
        let user = await firebase.auth().currentUser;
		resolve (user.uid)
	})
 }